import React from 'react'
import FormulaButton from '../formulaButton'
import SO3CorrectionForm from '../../container/so3CorrectionForm'

export default class BreakTimeButton extends React.Component {
    render() {
        return (
            <div>
                <FormulaButton label="SO3 Correction" iconName="breakTime">
                    <SO3CorrectionForm/>
                </FormulaButton>
            </div>
        )
    }
}